import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { categoryApi } from "../../../assets/apis";
import Spinner from "../../../spinner/first_spinner/Spinner";
import { useDispatch, useSelector } from "react-redux";
import {
  setSiderBarActiveLink,
  setSiderBarActiveList,
} from "../../../redux-store/sidebarActiveList";
import CoverSpin from "../../../spinner/second_spinner/CoverSpin";
import SecondSpinner from "../../../spinner/third_spinner/SecondSpinner";
import NotFoundWithImage from "../../../notFound/NotFoundWithImage/NotFoundWithImage";

const EditCategory = () => {
  const { FYear } = useSelector((store) => store.FinancialYear);
  const dispatch = useDispatch();
  const [editedCategoryData, setEditedCategoryData] = useState({});
  const navigate = useNavigate();
  const { id } = useParams();

  const { data, isError, isLoading, error, isFetching } = useQuery({
    queryKey: [id, FYear.value],
    queryFn: () =>
      axios.get(`${categoryApi}/${id}`).then((response) => response.data.data),
    retry: false,
  });

  useEffect(() => {
    if (data) {
      const { createdAt, updatedAt, companyId, id, ...rest } = data;
      setEditedCategoryData(rest);
    }
  }, [data]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEditedCategoryData((pre) => ({
      ...pre,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleInputChangeWithCondition = (e, validationRegex) => {
    const { name, value } = e.target;
    if (value === "" || validationRegex.test(value)) {
      setEditedCategoryData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (data) => {
      return axios.put(`${categoryApi}/${id}`, data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["category"]);
      toast.success("Category saved successfully!");
      navigate("/categories");
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.message;
      toast.error(` ${errorMessage}`);
    },
  });

  const handleSaveCategory = (e) => {
    e.preventDefault();
    const { name, description } = editedCategoryData;
    let updatedCategory = {
      ...editedCategoryData,
      name: name.trim(),
      ...(description && { description: description.trim() }),
    };
    setEditedCategoryData(updatedCategory);
    if (!updatedCategory.name) return toast.error("Please enter Category name");
    mutation.mutate(updatedCategory);
  };

  useEffect(() => {
    dispatch(setSiderBarActiveList({ name: "Items" }));
    dispatch(setSiderBarActiveLink({ link: "categories" }));
  }, []);

  if (isLoading || isFetching) {
    return (
      <div className="main-panel">
        <div className="content-wrapper">
          <SecondSpinner />
        </div>
      </div>
    );
  }

  if (isError) return <NotFoundWithImage />;

  return (
    <div className={`main-panel`}>
      <div className="content-wrapper">
        <div className="row">
          <div className="col-sm-12">
            <div className="d-flex justify-content-between m-1 p-1 align-items-baseline ">
              <h3 className="ukhd mb-3">Edit Category</h3>
              <button
                type="button"
                className="btn btn-warning btn-sm"
                onClick={() => navigate("/categories")}
              >
                <div className="d-flex justify-content-center">
                  <i className="mdi mdi mdi-keyboard-backspace"></i>
                  <span>Back</span>
                </div>
              </button>
            </div>
            <div className="row flex-grow">
              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card card-rounded">
                  <div className="card-body">
                    <div className="col-lg-12">
                      <div className="col-lg-12 ">
                        <h5>CATEGORY INFORMATION</h5>
                      </div>
                      <form onSubmit={handleSaveCategory}>
                        <div>
                          <div className="col-lg-4 mt-4">
                            <label>Name</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Category"
                              name="name"
                              required
                              value={editedCategoryData.name || ""}
                              onChange={(e) => {
                                handleInputChangeWithCondition(e, /^[\s\S]*$/);
                              }}
                            />
                          </div>
                          <div className="col-lg-6 mt-4">
                            <label>Active ? </label>{" "}
                            <input
                              type="checkbox"
                              name="active"
                              checked={editedCategoryData.active || ""}
                              onChange={handleInputChange}
                            />
                          </div>
                          <div className="col-lg-9 mt-4">
                            <label
                              className="form-control-label"
                              htmlFor="input-address"
                            >
                              Description
                            </label>
                            <textarea
                              className="form-control form-control-alternative"
                              rows="7"
                              style={{
                                borderRadius: "5px",
                                resize: "none",
                                minHeight: "80px",
                              }}
                              name="description"
                              value={editedCategoryData.description || ""}
                              onChange={handleInputChange}
                            />
                          </div>
                          <div className="col-lg-9 mt-2">
                            <button
                              type="submit"
                              className="btn btn-primary d-flex justify-content-center px-3 py-2"
                            >
                              <i className="mdi mdi-content-save me-1"></i> Save
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCategory;
